import React from 'react';
import insta from './images/insta.svg';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footerLinks">
          <div className="footerData">DRINKWATR, LLC. © 2026 | ALL RIGHTS RESERVED.</div>
          <a
            href="https://www.instagram.com/drinkwatr.io/?igsh=OXlqdmhwNW8yOXN5"
            target="_blank"
            rel="noopener noreferrer"
            className="insta"
          >
            <img src={insta} className="img-fluid mainInsta" alt="Instagram" />
          </a>
          <div className="footerData">
            <a href="#">Privacy</a> + <a href="#">legal</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;